import { tabsClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const name = 'SettingsNavTabs';

export const useSettingsNavTabsStyles = makeStyles({ name })(theme => ({
  mainRoot: {
    display: 'flex',
    maxWidth: '100%',
  },
  root: {
    display: 'flex',
    margin: theme.spacing(6, 4),
    borderBottom: `1px solid ${theme.palette.divider}`,
    width: '100%',
    overflow: 'hidden',
    minWidth: 0,

    [theme.breakpoints.up('xs')]: {
      display: 'none',
    },

    [`&& .${tabsClasses.root}`]: {
      minHeight: 'unset',
    },

    [`&& .${tabsClasses.indicator}`]: {
      height: 2,
    },

    [`&& .${tabsClasses.flexContainer}`]: {
      gap: theme.spacing(3),
    },
  },
  tab: {
    height: 34,
    fontWeight: 600,
    minWidth: 60,
    padding: 0,
  },
  dividerTab: {
    width: 40,
    minWidth: 40,
  },
}));
